import cx from 'classnames'

import Emoji from 'common/emoji'

import LinearLoader from './linearLoader'

interface Props {
  'data-cy'?: string
  size?: 'normal' | 'small'
  className?: string
}

const WidgetLoader: React.FC<Props> = ({
  'data-cy': dataCy,
  size = 'normal',
  className,
}) => {
  return (
    <div
      className={cx(
        'bg-coolGray-50 flex flex-col justify-center items-center rounded border border-coolGray-100',
        {
          'mb-6 px-12 py-14': size === 'normal',
          'px-6 py-5': size === 'small',
        },
        className
      )}
      data-cy={dataCy}
      data-testid="loader"
    >
      <Emoji
        symbol="⏳"
        className={cx('text-black', {
          'mb-8 text-5xl': size === 'normal',
          'mb-4 text-4xl': size === 'small',
        })}
      />
      <LinearLoader />
      <p
        className={cx('text-coolGray-500', {
          'mt-8': size === 'normal',
          'mt-4': size === 'small',
        })}
      >
        Waking up the server in the far corner…
      </p>
    </div>
  )
}

export default WidgetLoader
